<template>
  <v-row>
    <v-col>
      <v-card class="px-12 py-6">
        <v-row>
          <v-col cols="12" md="6" class="py-0">
            <v-row>
              <v-col cols="4" sm="2" md="4" lg="3" xl="2" class="py-1">
                <span class="font-weight-bold">ผู้ทำการลา</span>
              </v-col>
              <v-col class="py-1">
                <span>
                  {{ employeeName }}
                </span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="6" class="py-0">
            <v-row>
              <v-col cols="4" sm="2" md="4" lg="3" xl="2" class="py-1">
                <span class="font-weight-bold">ตำแหน่ง</span>
              </v-col>
              <v-col class="py-1">
                <span>
                  {{ positionName }}
                </span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="6" class="py-0">
            <v-row>
              <v-col cols="4" sm="2" md="4" lg="3" xl="2" class="py-1">
                <span class="font-weight-bold">สังกัด</span>
              </v-col>
              <v-col class="py-1">
                <span>
                  {{ orgNameAll }}
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    employeeName() {
      if (this.info.hasOwnProperty('employeeName')) {
        if (typeof this.info.employeeName !== 'object') {
          return this.info.employeeName
        } else {
          return this.info.employeeName[this.$lang]
        }
      } else {
        return ''
      }
    },

    positionName() {
      if (this.info.hasOwnProperty('positionName')) {
        if (typeof this.info.positionName !== 'object') {
          return this.info.positionName
        } else {
          return this.info.positionName[this.$lang]
        }
      } else {
        return ''
      }
    },

    orgNameAll() {
      if (this.info.hasOwnProperty('orgNameAll')) {
        if (typeof this.info.orgNameAll !== 'object') {
          return this.info.orgNameAll
        } else {
          return this.info.orgNameAll[this.$lang]
        }
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
